export default {
      id: "youtube-negative-usage",
      viewBox: "0 0 512 512",
      url: "/assets/svg/" + "sprite.svg#youtube-negative-usage",
      toString: function () {
        return this.url;
      }
    }